// Centralized styles for OwnerDashboard components

const styles = (theme) => ({
    valueStyle: {
        fontSize: 28,
        fontWeight: 600,
        marginTop: 8,
    },
    titleStyle: {
        fontSize: 16,
        color: '#888',
    },
    headerTextStyle: {
        color: '#3A5889',
        fontSize: 22,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
    },
    cellTextStyle: {
        color: '#121212',
        fontSize: 24,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
    },
    chartViewTitleStyle: {
        marginBottom: 16,
        color: '#345B9C',
        fontSize: 20,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
    },
    exportButtonStyle: {
        border: '1px solid #F5F5F5',
        background: '#FAFAFA',
        color: '#737375',
        marginBottom: 16,
        fontWeight: 500,
        textTransform: 'none',
        boxShadow: 'none',
    },
    dateRangeButtonStyle: {
        marginBottom: 16,
        color: '#fff',
        background: '#345B9C',
        border: '1px solid #F5F5F5',
        borderRadius: 8,
        padding: '8px 20px 8px 16px',
        fontWeight: 500,
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        textTransform: 'none',
    },
    dateRangeDialogContentStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
        padding: 16,
    },
    dateRangeCancelButtonStyle: {
        textTransform: 'none',
    },
    dateRangeApplyButtonStyle: {
        textTransform: 'none',
    },
    dateRangeInfoStyle: {
        width: '100%',
        marginBottom: 24,
        color: '#666',
        fontSize: 14,
        display: 'block',
    },
    dateRangeErrorStyle: {
        color: 'red',
        marginTop: 8,
        width: '100%',
        display: 'block',
    },
    dashboardLoadingContainerStyle: {
        padding: 32,
        textAlign: 'center',
    },
    dashboardLoadingTextStyle: {
        fontSize: 18,
        color: '#333',
    },
    dashboardErrorContainerStyle: {
        padding: 32,
        textAlign: 'center',
    },
    dashboardErrorTitleStyle: {
        fontWeight: 'bold',
        fontSize: 24,
        color: '#B00020',
    },
    dashboardErrorTextStyle: {
        fontSize: 18,
        marginTop: 8,
        color: '#333',
    },
    dashboardDividerStyle: {
        border: 'none',
        height: 2,
        background: '#E9E9E9',
        width: '98%',
        margin: '16px auto',
        borderRadius: 2,
    },
    dashboardCardsGridContainerStyle: {
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            padding: '0 20px',
        },
    },
    dashboardCardsGridItemStyle: {
        minWidth: 0,
        display: 'flex',
        justifyContent: 'center',
        width: '90%',
        margin: '10px auto',
        [theme.breakpoints.up('md')]: {
            width: 'auto',
            margin: 0,
        },
    },
    cardStyle: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.2)',
        width: '100%',
        flexGrow: 1,
        height: 120,
        borderRadius: 8,
        padding: '20px 10px 20px 10px',
        [theme.breakpoints.up('md')]: {
            padding: '40px 20px 40px 20px',
            minWidth: 160,
            maxWidth: 240,
            height: 160,
        },
    },
    cardHeaderStyle: {
        ...theme.titleStyle,
        fontSize: 24,
        [theme.breakpoints.up('md')]: {
            fontSize: 16,
        },
    },
    dashboardHeaderGridStyle: {
        width: '100%',
    },
    dashboardHeaderLeftStyle: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start',
        },
    },
    dashboardHeaderRightStyle: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-end',
        },
    },
    dashboardHeaderTitleStyle: {
        color: '#3A5889',
        fontSize: 24,
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 62,
        marginBottom: 16,
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start',
            marginBottom: 0,
        },
    },
    dashboardHeaderCenterStyle: {
        display: 'flex',
        justifyContent: 'center',
    },
    dashboardLoadingSpinnerStyle: {
        marginBottom: 16,
    },
    propertySelectorWrapper: {
        justifySelf: 'center',
        width: '100%',
        height: 64,
    },
});

export default styles;
